import script from "./LanguageSelectorBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelectorBlock.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelectorBlock.vue?vue&type=style&index=0&id=df675aec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df675aec"]])

export default __exports__